export const classStyleMaster: Array<{ value: string; label: string }> = [
    { value: '2', label: '集合型' },
    { value: '3', label: '個別指導' },
    { value: '1', label: 'オンライン' },
    { value: '4', label: '家庭教師・派遣型' },
];
